import { ChangeDetectorRef, Component, ElementRef, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Form, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { RouteAction } from '@core/action/action';
import { EntidadesService } from '@core/services/entidades.service';
import { MessageService } from '@core/services/message.service';
import { EntidadeSharedDataService } from '@modules/entidade/entidade-shared-data.service';
import { ModalOptions, NzModalService } from 'ng-zorro-antd/modal';
import { Location } from '@angular/common';
import { AuthenticationService } from '@core/auth/authentication.service';

import { NomePaginaEnum } from '@core/models/nome-pagina.enum';
import { converterItensVaziosEmNull, removerDuplicados } from '@shared/util/util';
import { contatoPrincipalDaLista, extrairId, mapearEntidadeSuperioresParaApi, normalizarEntidadeContatosParaApi, superioresSemId, tipoEntidadeExibeSecaoContatos } from './entidade-envio.util';
import { startWith } from 'rxjs';
import { DialogService } from '@core/services/dialog.service';
import { FormService } from '@core/services/form.service';
import { NotificationService } from '@core/services/notification.service';
import { TipoContatoEnum, TipoEntidadeEnum } from '@core/models/entidade';
import { ValidaCpfCnpjService } from '@core/services/validacpfcnpj.service';

import { VinculoService } from '@core/services/vinculo.service';
import { AtualizacaoContatoPessoaModalComponent } from '@modules/entidade/components/atualizacao-contato-pessoa-modal/atualizacao-contato-pessoa-modal.component';
import { DadosBasicosFormComponent } from '@modules/entidade/components/dados-basicos-form/dados-basicos-form.component';
import dayjs from 'dayjs';
import { PerfilEnum } from '@core/models/perfil';
import { RoleEnum } from '@core/models/role';
import { LoaderService } from '@shared/components/loader/loader.service';
@Component({
  selector: 'app-entidade-form',
  templateUrl: './entidade-form.component.html',
  styleUrl: './entidade-form.component.scss'
})
export class EntidadeFormComponent implements OnInit, OnDestroy {

  @ViewChild('formElement') formElement!: ElementRef;
  @ViewChild(DadosBasicosFormComponent) dadosBasicosForm!: DadosBasicosFormComponent;

  entidadeForm!: FormGroup;
  idParams!: number;
  acao!: RouteAction;
  acaoEnum = RouteAction;
  inserir!: boolean;
  editar!: boolean;
  visualizar!: boolean;
  actionActual!: RouteAction
  sucesso: boolean = false;
  nomeReduzidoEntidade: any;
  entidadeGrupos!: any;
  nomePagina: NomePaginaEnum = NomePaginaEnum.ENTIDADE;
  entidade: any;
  vinculos: any[] = [];
  endereco: any;
  esconderContatos: boolean = true;
  exibirSecaoContatos: boolean = true;
  cnpjValido: any;
  perfilEnum = PerfilEnum;
  roleEnum = RoleEnum;
  perfilUsuarioLogado: any;

  contato: any;
  dataSet: any;

  somenteVisualizar: boolean = false;
  mostrarMovimentacaoSocietaria: boolean = true;
  habilitarModalNotificarMovimentacao: boolean = false;
  objetoDeEnvio!: any;
  estaSalvando: boolean = false;
  carregandoComplemento = false;
  private entidadeCompletaCarregada = true;
  private idEntidadeCarregada: number | null = null;

  constructor(
    private fb: FormBuilder,
    private entidadesService: EntidadesService,
    private vinculoService: VinculoService,
    private route: ActivatedRoute,
    private entidadeSharedDataService: EntidadeSharedDataService,
    private messageService: MessageService,
    private location: Location,
    private modalService: NzModalService,
    private dialogService: DialogService,
    private formService: FormService,
    private notificationService: NotificationService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private validaCpfCnpjService: ValidaCpfCnpjService,
    private authenticationService: AuthenticationService,
    private loaderService: LoaderService

  ) { }

  ngOnDestroy(): void {
    this.loaderService.releaseAutomaticLoader();
  }

  ngOnInit(): void {
    this.checkUrl();
    this.construirForm();
    const acaoRota = this.route.snapshot.data['acao'] ?? this.acao;
    if (acaoRota) {
      this.acao = acaoRota;
    }
    this.inserir = this.acao == RouteAction.Inserir;
    this.editar = this.acao == RouteAction.Editar;
    this.visualizar = this.acao == RouteAction.Visualizar;
    if (this.editar || this.visualizar) {
      this.carregandoComplemento = true;
    }
    this.buscarDados();
    this.valueEntidadeParaNotificarMovimentacao();

    this.entidadeForm.get('tipoEntidadeId')?.valueChanges.pipe(
      startWith(this.entidadeForm.get('tipoEntidadeId')?.value)
    ).subscribe((value) => {
      this.atualizarVisibilidadeContatos(value);

      const tipoId = extrairId(value) as TipoEntidadeEnum;
      this.mostrarMovimentacaoSocietaria = [
        TipoEntidadeEnum.Seguradora,
        TipoEntidadeEnum.Previdencia,
        TipoEntidadeEnum.Saude,
        TipoEntidadeEnum.Capitalizacao
      ].includes(tipoId);

      this.cdr.detectChanges();
    });
    this.perfilUsuario();
  }

  valueEntidadeParaNotificarMovimentacao() {
    this.entidadeForm.get('tipoEntidadeId')?.valueChanges.subscribe((value) => {
      switch (value) {
        case TipoEntidadeEnum.Seguradora:
          this.habilitarModalNotificarMovimentacao = true;
          break;

        case TipoEntidadeEnum.Previdencia:
          this.habilitarModalNotificarMovimentacao = true;
          break;

        case TipoEntidadeEnum.Saude:
          this.habilitarModalNotificarMovimentacao = true;
          break;

        case TipoEntidadeEnum.Capitalizacao:
          this.habilitarModalNotificarMovimentacao = true;
          break;

        default:
          break;
      }
    })
  }

  construirForm() {
    this.entidadeForm = this.fb.group({
      tipoEntidadeId: ['', Validators.required],
      statusEntidadeId: [],
      flagEmpresaEstrangeira: [false],
      cnpj: [],
      numRegistroEmpresaEstrangeira: [],
      nomeRazaoSocial: [],
      nomeFantasia: [],
      sigla: [],
      representacao: [],
      anosMandato: [],
      cargosExistentes: [],
      // dataInicioMandato: [],
      //  dataFimMandato: [],
      tipoComissaoId: [],
      flagEntidadeSigilosa: [false],
      flagComissaoPermanente: [],
      entidadeAdministradoraId: [],
      pessoaAdminstradoraId: [],
      sigilosa: [false],
      permanente: [false],
      tipoComissao: [],
      pessoaAdministradoraId: [],
      tipoReguladora: [],
      grupoEconomico: [],
      entidadesAssociadas: [],
      empresaEstrangeira: [],
      numIdEmpEstrangeira: [],
      representacaoId: [],
      codigoReguladora: [],
      tipoReguladoraId: [],
      grupoEconomicoId: [],
      entidadeSuperiores: [],
      entidadeCargos: [],
      segmentacao: [],
      grupoAtualizacaoId: [],
      entidadeContatos: [],
      entidadeOutrosContatos: [],
    });
  }

  buscarDados() {
    if (this.editar || this.visualizar) {
      this.idParams = this.route.snapshot.params['id'];
      this.carregandoComplemento = true;
      this.entidadeCompletaCarregada = false;
      this.idEntidadeCarregada = this.idParams;
      this.loaderService.show();
      this.entidadesService.consultarIdBasico(this.idParams).subscribe({
        next: (res: any) => {
          this.aplicarDadosBasicos(res);
          this.loaderService.suppressAutomaticLoader();
          this.carregarComplemento(this.idParams);
        },
        error: () => {
          this.loaderService.hide();
          this.carregandoComplemento = false;
        }
      });
    }
  }

  private aplicarDadosBasicos(res: any): void {
    this.entidade = {
      ...res,
      entidadeContatos: res.entidadeContatos ?? [],
      entidadeDocumentos: res.entidadeDocumentos ?? [],
      entidadeGrupos: res.entidadeGrupos ?? [],
      entidadeObservacoes: res.entidadeObservacoes ?? [],
      entidadeCargos: res.entidadeCargos ?? [],
      mandatos: res.mandatos ?? [],
    };
    this.entidadeForm.patchValue(this.entidade, { emitEvent: false });
    this.entidadeForm.markAsPristine();
    this.dataSet = Array.isArray(this.entidade.entidadeContatos) ? this.entidade.entidadeContatos : [];
    this.contato = contatoPrincipalDaLista(this.dataSet);
    const tipoId = res.tipoEntidadeId ?? this.entidadeForm.get('tipoEntidadeId')?.value;
    this.atualizarVisibilidadeContatos(tipoId);
    this.mostrarMovimentacaoSocietaria = [
      TipoEntidadeEnum.Seguradora,
      TipoEntidadeEnum.Previdencia,
      TipoEntidadeEnum.Saude,
      TipoEntidadeEnum.Capitalizacao
    ].includes(Number(tipoId) as TipoEntidadeEnum);
    if (res.cnpj) {
      this.validaCpfCnpjService.validaCpfCnpj(res?.cnpj).subscribe((valid) => this.cnpjValido = valid);
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  private carregarComplemento(idParams: number): void {
    this.entidadesService.consultarId(idParams, true).subscribe({
      next: (full: any) => {
        this.aplicarComplemento(full);
        this.carregandoComplemento = false;
      },
      error: () => {
        this.entidadeCompletaCarregada = false;
        this.carregandoComplemento = false;
      }
    });
  }

  private aplicarComplemento(full: any): void {
    if (!full) {
      this.entidadeCompletaCarregada = true;
      return;
    }
    this.entidade = {
      ...this.entidade,
      ...full,
      tipoEntidadeId: this.entidade?.tipoEntidadeId ?? full.tipoEntidadeId,
      nomeTipoEntidade: this.entidade?.nomeTipoEntidade ?? full.nomeTipoEntidade,
    };
    this.dataSet = Array.isArray(this.entidade.entidadeContatos) ? this.entidade.entidadeContatos : [];
    this.contato = contatoPrincipalDaLista(this.dataSet);
    this.preencherSeNaoEditado('entidadeContatos', full.entidadeContatos ?? []);
    this.preencherSeNaoEditado('entidadeDocumentos', full.entidadeDocumentos ?? []);
    this.preencherSeNaoEditado('entidadeGrupos', full.entidadeGrupos ?? []);
    this.preencherSeNaoEditado('entidadeCargos', full.entidadeCargos ?? []);
    this.preencherSeNaoEditado('entidadeObservacoes', full.entidadeObservacoes ?? []);
    this.preencherSeNaoEditado('entidadeSuperiores', full.entidadeSuperiores ?? []);
    this.preencherSeNaoEditado('segmentacao', full.segmentacao);
    this.preencherSeNaoEditado('tipoAssociacao', full.tipoAssociacao);
    this.preencherSeNaoEditado('entidadeAfins', full.entidadeAfins ?? []);
    this.preencherSeNaoEditado('emailAprovador', full.emailAprovador);
    this.preencherSeNaoEditado('mandatos', full.mandatos ?? []);
    this.preencherSeNaoEditado('email', full.email);
    this.entidadeCompletaCarregada = true;
  }

  private preencherSeNaoEditado(campo: string, valor: any): void {
    const control = this.entidadeForm.get(campo);
    if (!control || control.dirty) {
      return;
    }
    control.setValue(valor, { emitEvent: false });
    control.markAsPristine();
  }

  private garantirComplemento(continuar: () => void): void {
    if (this.entidadeCompletaCarregada || this.inserir) {
      continuar();
      return;
    }
    const id = this.idEntidadeCarregada ?? this.idParams ?? this.entidade?.id;
    if (!id) {
      continuar();
      return;
    }
    this.entidadesService.consultarId(id, true).subscribe({
      next: (full) => {
        this.aplicarComplemento(full);
        continuar();
      },
      error: () => {
        this.notificationService.warn(
          'Atenção!',
          'Não foi possível carregar todos os dados da entidade. Tente salvar novamente.'
        );
      },
    });
  }

  submit() {
    const messages = this.formService.getValidationsMessages(this.entidadeForm, this.formElement);
    this.formService.validateAllFormFields(this.entidadeForm);

    let objEnvio = { ...this.entidade, ...this.entidadeForm.getRawValue() };
    const camposObrigatorios = this.getCamposObrigatoriosNaoPreenchidos(this.entidadeForm);

    if (!objEnvio.cnpjValido && objEnvio.cnpj) {
      messages.push('CNPJ inválido');
      camposObrigatorios.push('CNPJ inválido');
    }

    const tipoAssociacaoInvalido = objEnvio.representacaoId === 1 && !objEnvio.tipoAssociacao;
    if (tipoAssociacaoInvalido) {
      this.dadosBasicosForm.marcarTipoAssociacaoComoInvalido();
    }

    if (messages.length) {
      this.notificationService.warn(
        'Atenção!',
        `Existem campos obrigatórios a serem preenchidos: ${camposObrigatorios.join(', ')}.`
      );
      return;
    }

    if (tipoAssociacaoInvalido) {
      return;
    }

    this.garantirComplemento(() => this.done());
  }


  getCamposObrigatoriosNaoPreenchidos(formGroup: FormGroup): string[] {
    const camposNaoPreenchidos: string[] = [];

    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);

      if (control?.invalid && control?.errors?.['required']) {
        const label = this.getLabelDoCampo(key);
        camposNaoPreenchidos.push(label);
      }
    });

    return camposNaoPreenchidos;
  }

  // getLabelDoCampo(key: string): string {
  //   const elementoDOM = document.querySelector(`[formControlName="${key}"]`);
  //   return elementoDOM?.getAttribute('nzPlaceHolder') || this.getNomeAmigavelCampo(key);
  // }

  getLabelDoCampo(key: string): string {
    const elementoDOM = document.querySelector(`[formControlName="${key}"]`);

    // Buscar o texto do label associado
    const labelElement = elementoDOM?.closest('.col-md-6')?.querySelector('label.form-label');
    if (labelElement) {
      return labelElement.textContent?.trim() || this.getNomeAmigavelCampo(key);
    }

    // Caso não encontre o label, fallback para nome amigável
    return this.getNomeAmigavelCampo(key);
  }

  getNomeAmigavelCampo(campo: string): string {
    return campo.charAt(0).toUpperCase() + campo.slice(1);
  }


  perfilUsuario() {
    this.perfilUsuarioLogado = this.authenticationService?.currentUserValue?.perfil?.perfil;

    if (!this.perfilUsuarioLogado.includes(PerfilEnum.Administrador, PerfilEnum.Validador)) {
      this.somenteVisualizar = true;
    }
  }

  done(): void {
    const trueSave = true;
    // Deep copy para evitar perder dados quando dispara ngOnChanges
    let objEnvio = JSON.parse(JSON.stringify({ ...this.entidade, ...this.entidadeForm.getRawValue() }));

    // Validação: para tipos Órgão, Comissão, Subcomissão ou Grupo de Trabalho, é obrigatório ter hierarquia
    const tipoEntidade = objEnvio.tipoEntidadeId;
    if (this.dadosBasicosForm.isOrgao(tipoEntidade) || this.dadosBasicosForm.isComissao(tipoEntidade) || this.dadosBasicosForm.isSubcomissao(tipoEntidade) || this.dadosBasicosForm.isGrupoTrabalho(tipoEntidade)) {
      let cargos = this.entidadeForm.get('entidadeCargos')?.value || [];

      // Se cargos é um objeto com dataSet, extrair o array
      if (cargos && typeof cargos === 'object' && !Array.isArray(cargos) && cargos.dataSet) {
        cargos = cargos.dataSet;
      }

      // Garantir que é um array
      if (!Array.isArray(cargos)) {
        cargos = [];
      }

      if (cargos.length === 0) {
        this.notificationService.warn('Atenção!', 'É obrigatório informar pelo menos um cargo para este tipo de entidade.');
        return;
      }
    }

    objEnvio.cnpjValido = this.onCnpjValid(objEnvio.cnpj);

    if (objEnvio.dataControleAtualizacao) {
      objEnvio.dataControleAtualizacao = dayjs(objEnvio.dataControleAtualizacao)?.toISOString();
    }

    if (objEnvio.cnpjValido && objEnvio.cnpj) {
      delete objEnvio.cnpjValido
    }

    objEnvio.entidadeSuperiores = mapearEntidadeSuperioresParaApi(objEnvio?.entidadeSuperiores);
    if (superioresSemId(objEnvio.entidadeSuperiores)) {
      this.notificationService.warn('Atenção!', 'Selecione a entidade superior antes de salvar.');
      return;
    }

    objEnvio.entidadeContatos = normalizarEntidadeContatosParaApi(
      objEnvio?.entidadeContatos,
      objEnvio?.entidadeOutrosContatos,
    );
    delete objEnvio.entidadeOutrosContatos;

    objEnvio.entidadeContatos.forEach((contato: any) => {
      if (contato?.flagPrincipal) {
        contato.tipoContato = { id: TipoContatoEnum.ENDERECO };
      }
      if (contato?.flagPrincipal === null) {
        contato.flagPrincipal = true;
      }
    });

    // const outrosContatos = this.entidade?.entidadeContatos.filter((contato: any) => contato?.flagPrincipal === false);
    // if(!objEnvio.entidadeOutrosContatos && outrosContatos) {
    //   objEnvio.entidadeContatos = objEnvio.entidadeContatos.concat(outrosContatos);
    // }

    objEnvio.entidadeContatos = removerDuplicados(objEnvio?.entidadeContatos);

    objEnvio = converterItensVaziosEmNull(objEnvio);
    if (typeof objEnvio.cnpj === 'string') {
      objEnvio.cnpj = objEnvio.cnpj.replace(/\D/g, '');
    }

    // Se entidadeCargos tiver dataSet, extrai apenas os objetos do array
    if (objEnvio.entidadeCargos?.dataSet) {
      objEnvio.entidadeCargos = objEnvio.entidadeCargos.dataSet;
    }

    console.log(objEnvio);
    this.objetoDeEnvio = objEnvio;

    if (trueSave) {
      this.dialogService.confirm(
        `Deseja realmente ${objEnvio.id ? 'editar' : 'cadastrar'} a entidade?`,
        () => {
          if (objEnvio.id) {
            this.editarSubmit(objEnvio);
          } else {
            this.salvarSubmit(objEnvio);
          }
        }
      );
    }
  }


  salvarSubmit(objEnvio: any) {
    this.estaSalvando = true;
    this.entidadesService.salvar(objEnvio).subscribe((res: any) => {
      this.sucesso = true;
      this.messageService.success(`Entidade salva com sucesso!!!`);
      this.idParams = res?.id ?? null;
      this.estaSalvando = false;
      this.resetFormularios();
    }, (error) => {
      this.estaSalvando = false;
    });
  }

  editarSubmit(objEnvio: any) {
    this.estaSalvando = true;
    let modalFechado = false;

    const originalObj = this.entidade.entidadeContatos;
    const previousObj = objEnvio.entidadeContatos;
    const isEqual = this.areArraysEqual(originalObj, previousObj);

    if (!isEqual) {
      this.vinculoService.buscarPorEntidade(objEnvio.id).subscribe(async res => {
        this.vinculos = res;

        if (this.vinculos && this.vinculos.length > 0 && objEnvio.entidadeContatos[0]) {
          this.modalService.confirm({
            nzTitle: 'Deseja atualizar o endereço das pessoas que estão utilizando o contato da entidade no vínculo?',
            nzOkText: 'Sim',
            nzCancelText: 'Não',
            nzOnOk: async () => {

              modalFechado = await this.showModal(this.vinculos, objEnvio);
              if (modalFechado) {
                this.modalFechadoFn(objEnvio);
              }
            },
            nzOnCancel: () => {
              modalFechado = true;
              this.modalFechadoFn(objEnvio);
            }
          });

        } else {
          modalFechado = true;
          if (modalFechado) {
            this.modalFechadoFn(objEnvio);
          }
        }
      }, (error) => {
        this.estaSalvando = false;
      });
    } else {
      this.modalFechadoFn(objEnvio);
    }
  }

  modalFechadoFn(objEnvio: any) {
    this.loaderService.releaseAutomaticLoader();
    this.entidadesService.editar(objEnvio).subscribe(res => {
      this.loaderService.suppressAutomaticLoader();
      if (this.endereco) {
        this.vinculoService.editarVinculosContatos(this.endereco).subscribe();
      }
      this.sucesso = true;
      this.messageService.success(`Entidade editada com sucesso!!!`);
      this.estaSalvando = false;
      this.resetFormularios();
    }, () => {
      this.estaSalvando = false;
      this.loaderService.suppressAutomaticLoader();
    });
  }


  showModal(vinculos?: any[], objEnvio?: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const config: ModalOptions<AtualizacaoContatoPessoaModalComponent> = {
        nzTitle: 'Registros de Vínculo que Utilizam o Endereço da Entidade',
        nzContent: AtualizacaoContatoPessoaModalComponent,
        nzCentered: true,
        nzFooter: null,
        nzMaskClosable: false,
        nzWidth: '50vw', // Reduza o tamanho do modal (40% da largura da tela)
        nzBodyStyle: {
          height: '200px', // Altura fixa do modal
          width: '100%', // Largura fixa do modal
          overflow: 'auto', // Permite rolagem caso o conteúdo ultrapasse
        },
        nzOnOk: () => resolve(true),
        nzOnCancel: () => resolve(false),
        nzClosable: false,
      };

      const modalRef = this.modalService.create(config);
      modalRef.componentInstance!.novoContato = objEnvio.entidadeContatos[0];
      modalRef.componentInstance!.vinculos = this.vinculos;

      modalRef.afterClose.subscribe((result: any) => {
        resolve(true);
        this.endereco = result;
      });
    });
  }


  resetFormularios() {
    // Só reseta após terminar de salvar
    if (!this.estaSalvando) {
      this.entidadeSharedDataService.setResetForm(true);
      this.modalVoltar();
    }
  }



  voltar(): void {
    this.router.navigate(['/entidade']);
  }

  verificarAlteracaoNomeRazaoSocial(): boolean {
    const nomeAtual = this.entidade?.nomeRazaoSocial;
    return nomeAtual !== this.objetoDeEnvio?.nomeRazaoSocial;
  }

  modalVoltar(): void {
    const nomeAtualEditado = this.entidade?.nomeRazaoSocial !== this.objetoDeEnvio?.nomeRazaoSocial;
    const abrirModalNotificacao = this.editar && nomeAtualEditado && this.habilitarModalNotificarMovimentacao;

    if (abrirModalNotificacao) {
      this.modalNotificarMovimentacao();
    }
    else {
      this.modalService.confirm({
        nzTitle: 'Deseja voltar para página de consulta?',
        // nzContent: 'Os dados não salvos serão perdidos.',
        nzOkText: 'Sim',
        nzCancelText: 'Não',
        nzOnOk: () => {
          this.voltar();
        },
        nzOnCancel: () => {
          if (this.inserir) {
            this.router.navigate([`/entidade/editar/${this.idParams}`]);
          } else {
            this.buscarDados();
          }
        }
      });
    }
  }

  modalNotificarMovimentacao() {
    this.modalService.info({
      nzTitle: 'Uma movimentação societária referente à alteração da razão social foi registrada e adicionada ao histórico da entidade.',
      nzOkText: 'Ok',
      nzOnOk: () => {
        this.modalService.confirm({
          nzTitle: 'Deseja voltar para página de consulta?',
          nzOkText: 'Sim',
          nzCancelText: 'Não',
          nzOnOk: () => {
            this.voltar();
          },
          nzOnCancel: () => {
            if (this.inserir) {
              this.router.navigate([`/entidade/editar/${this.idParams}`]);
            } else {
              this.buscarDados();
            }
          }
        });
      },
    });
  }

  checkUrl() {
    this.acao = this.route.snapshot.data['acao'];
    this.inserir = this.acao == RouteAction.Inserir;
    this.editar = this.acao == RouteAction.Editar;
    this.visualizar = this.acao == RouteAction.Visualizar;
    this.route.data.subscribe((data) => {
      this.acao = data['acao'];
      this.inserir = this.acao == RouteAction.Inserir;
      this.editar = this.acao == RouteAction.Editar;
      this.visualizar = this.acao == RouteAction.Visualizar;
      this.atualizarVisibilidadeContatos(this.entidadeForm?.get('tipoEntidadeId')?.value);
    });
  }

  private atualizarVisibilidadeContatos(tipoEntidadeId: unknown): void {
    this.esconderContatos = tipoEntidadeExibeSecaoContatos(tipoEntidadeId);
    // Cadastro sempre exibe (CNSG-883). Edição/visualização também, inclusive Área (CNSG-877).
    this.exibirSecaoContatos = this.inserir || this.editar || this.visualizar || this.esconderContatos;
  }

  isAdministrador() {
    return this.perfilUsuarioLogado === PerfilEnum.Administrador || this.perfilUsuarioLogado === PerfilEnum.Validador;
  }

  onCnpjValid(value: any) {
    let cnpj = value;
    this.validaCpfCnpjService.validaCpfCnpj(cnpj).subscribe((res) => {
      return res
    });
  }

  deepEqual(obj1: { [x: string]: any; } | null, obj2: { [x: string]: any; } | null) {
    const strObj1 = JSON.stringify(obj1);
    const strObj2 = JSON.stringify(obj2);
    return strObj1 === strObj2;
  }

  areArraysEqual(arr1: string | any[], arr2: string | any[]) {
    if (arr1.length !== arr2.length) {
      return false;
    }
    for (let i = 0; i < arr1.length; i++) {
      if (!this.deepEqual(arr1[i], arr2[i])) {
        return false;
      }
    }
    return true;
  }

  receberDadosContato(event: any) {
    if (event) {
      this.entidadeForm.get('entidadeContatos')?.setValue(event);
    }
  }

  atualizarDadosMovimentacao(event: any) {
    console.log(event);
    this.idParams = this.route.snapshot.params['id'];
    this.entidadesService.consultarId(this.idParams).subscribe((res: any) => {
      this.nomeRazaoSocialControl?.setValue(event?.nomeRazaoSocial);
    });
  }

  get nomeFantasiaControl() {
    return this.entidadeForm.get('nomeFantasia');
  }

  get nomeRazaoSocialControl() {
    return this.entidadeForm.get('nomeRazaoSocial');
  }
}

